/**
 * ローカルストレージのユーティリティ関数
 */

// ストレージのキー定数
export const STORAGE_KEYS = {
  POINT_BALANCE_VISIBLE: 'point_balance_visible',
  PREPAID_BALANCE_VISIBLE: 'prepaid_balance_visible'
};

/**
 * ローカルストレージから値を取得する
 * @param key ストレージのキー
 * @returns 保存された値、存在しない場合はnull
 */
export const getStorageItem = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.error(
      `ローカルストレージからの読み込みに失敗しました (${key})`,
      error
    );
    return null;
  }
};

/**
 * ローカルストレージに値を保存する
 * @param key ストレージのキー
 * @param value 保存する値
 */
export const setStorageItem = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.error(`ローカルストレージへの保存に失敗しました (${key})`, error);
  }
};

/**
 * ローカルストレージから値を削除する
 * @param key ストレージのキー
 */
export const removeStorageItem = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`ローカルストレージからの削除に失敗しました (${key})`, error);
  }
};

/**
 * ローカルストレージからブール値を取得する
 * @param key ストレージのキー
 * @param defaultValue 存在しない場合のデフォルト値
 * @returns 保存されたブール値、存在しない場合はデフォルト値
 */
export const getStorageBoolean = (
  key: string,
  defaultValue = true
): boolean => {
  const value = getStorageItem(key);
  if (value === null) return defaultValue;
  if (value !== 'true' && value !== 'false') return defaultValue;
  return value === 'true';
};

/**
 * ローカルストレージにブール値を保存する
 * @param key ストレージのキー
 * @param value 保存するブール値
 */
export const setStorageBoolean = (key: string, value: boolean): void => {
  setStorageItem(key, value.toString());
};
